"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAny = exports.mapObject = exports.isIterable = void 0;
/**
 * Determine whether the given `input` is iterable.
 *
 * @returns {Boolean}
 */
function isIterable(input) {
    if (input === null || typeof input !== 'object') {
        return false;
    }
    if (input instanceof Array)
        return true;
    return typeof input[Symbol.iterator] === 'function';
}
exports.isIterable = isIterable;
function mapObject(obj, callbackfn) {
    const result = {};
    Object.entries(obj).forEach(([key, value]) => {
        result[key] = callbackfn(value, key);
    });
    return result;
}
exports.mapObject = mapObject;
function mapAny(obj, callbackfn) {
    if (isIterable(obj)) {
        return Array.from(obj).map(callbackfn);
    }
    return mapObject(obj, callbackfn);
}
exports.mapAny = mapAny;
//# sourceMappingURL=helpers.js.map